import React from "react";

const resumeEntries = [
  {
    date: "Oct 2024 - Present",
    title: "Head of Engineering",
    position: "Career-Bond · Contract Full-time",
    description:
      "As Head of Engineering at CareerBond, I lead the design, development, and delivery of a financial technology platform helping educational institutions offer tuition financing options. I oversee the entire engineering lifecycle—from system architecture and roadmap planning to implementation and deployment. I architected and scaled backend services using AWS Lambda, API Gateway, and Node.js to handle lead routing, school-program matching, and loan application workflows. On the frontend, I led the development of responsive UIs using React and Next.js to support student onboarding and partner dashboards. I also integrated third-party APIs like Zoho CRM, Leadhoop, and Firebase for seamless automation, data sync, and real-time tracking. In addition, I introduced CI/CD pipelines, agile processes, and documentation standards to improve team productivity and system reliability. My role involves managing a fully remote engineering team, mentoring developers, and collaborating cross-functionally with product, design, and operations to launch high-impact features under tight deadlines.",
  },
  {
    date: "Jan 2023 - Feb 2024",
    title: "Full Stack Engineer",
    position: "Assure DeFi · Freelance",
    description:
      "Driving end-to-end development of DeFi solutions focused on investor trust, compliance, and scalable Web3 infrastructure. Architected and delivered full-stack dashboards using React.js and Node.js for token vesting, KYC workflows, and smart contract verification. Built and optimized RESTful APIs integrating on-chain data and third-party Web3 services, enabling real-time analytics and automation. Led development of no-code and low-code solutions with Bubble.io to accelerate internal operations and reduce onboarding time for clients. Managed and extended WordPress-based systems for order processing and KYC management across multiple product lines. Owned website performance and UX improvements via Webflow, aligning marketing and product funnels. Collaborated with cross-functional teams to streamline CI/CD pipelines and improve deployment velocity. Contributed to platform architecture decisions focused on modularity, scalability, and maintainability.",
  },
  {
    date: "Feb 2023 - Sep 2024",
    title: "Software Engineer",
    position: "P&P Optica · Permanent Full-time",
    description:
      "Developed scalable, data-intensive applications for real-time food inspection systems powered by AI and hyperspectral imaging. Built React.js dashboards and Node.js/Python backend services to process and visualize high-volume data streams. Leveraged AWS (Lambda, S3, API Gateway, CloudFront, Cognito) to design reliable, cloud-native solutions, contributing to improved system performance, data accuracy, and deployment efficiency.",
  },
  {
    date: "Dec 2017 - Jan 2023",
    title: "Head of Mobile and Web Development",
    position: "Lynk Remote Technologies, LLC · Contract Full-time",
    description:
      "Led a team in developing IoT devices, mobile apps, and APIs for Lynk Remote Technologies, LLC. Implemented serverless and server-based architecture for remote access camera systems. Planned and executed features to enhance user experience and functionality.",
  },
  {
    date: "Jan 2018 - Apr 2019 (part-time)",
    title: "Mobile Solution Development",
    position: "Conestoga College - Kitchener, ON",
    description:
      "GPA 3.71. Dean's Honour List recognition. Studied systems development life cycle, web design and development principles, quality assurance, SQL, iOS, Android, and application security.",
  },
  {
    date: "Nov 2013 - Dec 2017",
    title: "Full-stack Developer",
    position: "InfoStride · Permanent Full-time",
    description:
      "Built scalable web applications and eCommerce platforms using PHP and CodeIgniter. Developed REST APIs and integrated third-party services such as Stripe, Google, and Facebook. Designed database schemas and optimized SQL performance. Converted UI/UX designs into responsive web applications. Deployed and maintained applications on AWS infrastructure.",
  },
  {
    date: "2009 - 2013",
    title: "Bachelor of Technology, Computer Science Engineering",
    position: "Shaheed Bhagat Singh State Technical Campus, Punjab, India",
    description:
      "Studied data structures, algorithms, databases, object-oriented programming, computer networks, and digital logic as part of a strong computer science engineering foundation.",
  },
];

function Resume() {
  return (
    <section className="ftco-section ftco-no-pb" id="resume-section">
      <div className="container">
        <div className="row justify-content-center pb-5">
          <div className="col-md-10 heading-section text-center">
            <h1 className="big big-2">Resume</h1>
            <h2 className="mb-4">Resume</h2>
          </div>
        </div>

        <div className="row">
          {resumeEntries.map((entry) => (
            <div className="col-md-6 mb-4" key={entry.title}>
              <div className="resume-wrap h-100">
                <span className="date">{entry.date}</span>
                <h2>{entry.title}</h2>
                <span className="position">{entry.position}</span>
                <p className="mt-4">{entry.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Resume;
